<script setup lang="ts">
    // @ts-nocheck
    import { computed, onBeforeMount, ref, toRefs } from "vue";
    import KForm from "@/components/forms/Form/KForm.vue";
    import { getErrorMessage } from "@/api";
    import { flashMessage, openDialog } from "@/utils";
    import DialogAktivPatient from "@/tabs/Operation/DialogAktivPatient.vue";
    import DialogVardplatsbestallningInfo from "@/tabs/Vardplatsbokning/DialogVardplatsbestallningInfo.vue";
    import {
        VardplatsbestallningStryk as VardplatsbestallningStrykType,
        VardplatsStatus,
    } from "@/tabs/Vardplatsbokning/types";
    import { useStore } from "@/store";

    const store = useStore();

    const props = defineProps<{
        vardplatsbestallningId: string;
    }>();

    const { vardplatsbestallningId } = toRefs(props);

    const formRef = ref();

    const vardplatsbestallning = computed(() =>
        store.getters["vardplatsbestallning/vardplatsbestallningById"]({ id: vardplatsbestallningId.value })
    );

    const onSubmit = async (formData: VardplatsbestallningStrykType) => {
        try {
            await store.dispatch("vardplatsbestallning/strykVardplatsbestallning", {
                vardplatsbestallning: {
                    ...formData,
                    id: vardplatsbestallningId.value,
                    status: VardplatsStatus.STRUKEN,
                },
            });

            flashMessage("Vårdplatsbeställningen struken");

            emit("close");
        } catch (e) {
            openDialog("Det gick inte att stryka vårdplatsbeställningen. " + getErrorMessage(e), "error");
        }
    };

    const emit = defineEmits(["close", "onSuccess"]);

    const onCancel = () => {
        emit("close");
    };

    onBeforeMount(async () => {
        await store.dispatch("vardplatsbestallning/getVardplatsbestallningById", {
            id: vardplatsbestallningId.value,
        });
    });
</script>

<template>
    <div class="stryk-vardplatsbestallning">
        <DialogAktivPatient :patient="vardplatsbestallning.patient" />
        <DialogVardplatsbestallningInfo :vardplatsbestallning="vardplatsbestallning" />
        <KForm
            ref="formRef"
            id="stryk-vardplatsbestallning-form"
            class="stryk-vardplatsbestallning-form"
            submitSize="secondary"
            submitVariant="alert"
            submitContent="Stryk vårdplats"
            cancelSize="slim"
            cancelVariant="contour"
            cancelContent="Avbryt"
            @submit="onSubmit"
            @cancel="onCancel"
        >
            <template #default>
                <div class="form-content">
                    <KText type="textarea" name="strykningsorsak" label="Orsak" class="span-all" />
                    <FormulateInput type="checkbox" name="patient_utebliven" label="Patient utebliven" />
                </div>
            </template>
        </KForm>
    </div>
</template>
